import React from "react";
import "./cryptogate.scss";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../store/index.ts";
import ShowContainer from "../../../mui/ShowContainer";
import CusInput from "../../../mui/custom_input/CusInput.jsx";
import IconWarning from "../../../mui/JSXIcons/IconWarning.jsx";

export default function Cryptogate({ info }) {
  const { t } = useTranslation();
  const currency = useAppSelector((state) => state.user.currency);
  const network = `${info.name} ${info.ticker}`;

  return (
    <div className="top-up top-up__crypto">
      <p>
        {t("Send_")} <span> {t("any amount")} </span>{" "}
        {t("to the address below and the amount will be")}
        <span>
          {" "}
          {t("credited to your balance in")} {currency}{" "}
        </span>
        {t("at the current rate.")}
      </p>

      <p>
        {t("Enrollment will take place automatically after confirmation by the crypto network.")}
      </p>

      <ShowContainer condition={network}>
        <div className="top-up__crypto__warning">
          <IconWarning color="#f00" />
          <span className="top-up__crypto__warning__text">
            <span>{t("Send only network")}</span>
            <span className="top-up__crypto__warning__red">
              <span>{network}</span>
            </span>
          </span>
        </div>
      </ShowContainer>

      <CusInput isCopy readOnly defaultValue={info.address} />
    </div>
  );
}
